import React, { useState } from 'react';
import './Support.scss';
import { PageTemplate } from '../../layout/PageTemplate/PageTemplate';
import { Card } from 'primereact/card';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { CreateTicketForm } from './components/CreateTicketForm';
import { TicketsList } from './components/TicketsList';
import { Route } from 'react-router-dom';
import { NavElement } from '../../types/navigation';
import { TicketDetail } from './TicketDetail/TicketDetail';
import { SUPPORT_TICKET_PATH } from '../../config/routePaths';

// Preguntas frecuentes
const FAQ_ITEMS = [
  {
    question: '¿Cómo puedo crear una nueva reserva?',
    answer:
      'Para crear una nueva reserva, ve a la sección "Reservas" y elige un tipo de reserva. Ahora puedes hacer clic en el botón "Nueva reserva", clickar en una hora del calendario o seleccionar horas en el calendario arrastrando. Aparecerá el panel de reservas, donde puedes rellenar los datos de la reserva.',
  },
  {
    question: '¿Cómo puedo cancelar una reserva?',
    answer:
      'Para cancelar una reserva, ve a la sección "Reservas", encuentra la reserva que deseas cancelar y haz clic en ella. En el panel de detalles, haz clic en el botón "Cancelar reserva" y confirma la acción.',
  },
  {
    question: '¿Cómo puedo gestionar mis clientes?',
    answer:
      'Para gestionar tus clientes, ve a la sección "Usuarios" donde podrás ver, añadir, editar y eliminar clientes. También puedes ver el historial de reservas y rutinas de cada cliente.',
  },
  {
    question: '¿Cómo puedo crear una rutina para un cliente?',
    answer:
      'Para crear una rutina, ve a la sección "Rutinas", haz clic en "Nueva rutina" y selecciona el cliente. Luego, añade los ejercicios deseados, configura las series y repeticiones, y guarda la rutina.',
  },
  {
    question: '¿Cómo puedo ver las analíticas de mi negocio?',
    answer:
      'Para ver las analíticas de tu negocio, ve a la sección "Métricas" donde encontrarás gráficos y datos sobre reservas, ingresos, clientes activos y más información relevante para tu negocio.',
  },
];

const SupportContent = () => {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [refreshTickets, setRefreshTickets] = useState(0);

  const handleTicketCreated = () => {
    setShowCreateForm(false);
    setRefreshTickets((prev) => prev + 1);
  };

  return (
    <div className='support-content-wrapper'>
      <div className='support-content'>
        <div className='form-section'>
          {!showCreateForm ? (
            <>
              <Card className='tickets-info-card'>
                <div className='card-header'>
                  <i className='pi pi-info-circle card-icon'></i>
                  <h4>Sistema de tickets</h4>
                </div>
                <Divider />
                <p className='tickets-info-text'>
                  La manera de comunicarte con nosotros en cuanto a errores, mejoras o modificaciones es a través del
                  sistema de tickets, ya que esto nos crea una tarea en nuestro sistema y nos mantiene al tanto para
                  elegirla.
                </p>
              </Card>
              <TicketsList key={refreshTickets} />
              <div className='tickets-actions'>
                <Button
                  label='Nuevo ticket'
                  icon='pi pi-plus'
                  onClick={() => setShowCreateForm(true)}
                  className='new-ticket-button'
                />
              </div>
            </>
          ) : (
            <CreateTicketForm onTicketCreated={handleTicketCreated} onCancel={() => setShowCreateForm(false)} />
          )}

          {!showCreateForm && (
            <Card className='faq-card'>
            <div className='card-header'>
              <i className='pi pi-question-circle card-icon'></i>
              <h4>Preguntas frecuentes</h4>
            </div>
            <Divider />
            <p className='subtitle'>Encuentra respuestas a las preguntas más comunes sobre nuestra plataforma.</p>

            <Accordion multiple>
              {FAQ_ITEMS.map((item, index) => (
                <AccordionTab key={index} header={item.question}>
                  <p>{item.answer}</p>
                </AccordionTab>
              ))}
            </Accordion>
            </Card>
          )}
        </div>

        <div className='contact-section'>
          <Card className='contact-method'>
            <div className='card-header'>
              <i className='pi pi-envelope card-icon'></i>
              <h4>Correo electrónico</h4>
            </div>
            <Divider />
            <p>Envíanos un correo y nos pondremos en contacto contigo lo antes posible.</p>
            <Button
              className='contact-button'
              label='info@no-gravity.es'
              text
              icon='pi pi-envelope'
              onClick={() => window.open('https://mail.google.com/mail/?view=cm&fs=1&to=info@no-gravity.es')}
            />
            <Button
              className='contact-button'
              label='info@no-gravity.net'
              text
              icon='pi pi-envelope'
              onClick={() => window.open('https://mail.google.com/mail/?view=cm&fs=1&to=info@no-gravity.net')}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};

const supportRoutes: NavElement[] = [
  {
    label: 'Soporte',
    element: <SupportContent />,
    url: '/',
  },
  {
    label: 'Detalle del ticket',
    element: <TicketDetail />,
    url: SUPPORT_TICKET_PATH,
  },
];

export const Support = () => {
  return (
    <PageTemplate title='Soporte' parentRoute='/support' routes={supportRoutes} className='support-page'>
      {supportRoutes.map(({ element, url }) => (
        <Route key={url} path={url} element={element} />
      ))}
    </PageTemplate>
  );
};
